'use client';
import { SavedBlock as Shared } from '@launchstore/shared-puck';
export const SavedBlock: any = Shared;
export default SavedBlock;
